import { Mapper } from '@data/base/mapper';
export class ApiSecundariaMapper extends Mapper<any> {
  fromJson(param: any): any {
    return param;
  }
}
